import { authorizerTokenCookie } from '../types/authenticationContext.types';
import cookies from 'browser-cookies';

export const getBearerAuth0Token = (): string =>
	'Bearer ' + cookies.get(authorizerTokenCookie);
